/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSecurityService() {
        let securityService = {};
        securityService.getRolePermissions = function (){
            return axios.get("/api/SecurityService/GetRolePermissions");
        };
        securityService.updatePassword = function (request){
            return axios.post("/api/SecurityService/UpdatePassword", request);
        };
        securityService.getAllCustomerUsers = function (request){
            return axios.post("/api/SecurityService/GetAllCustomerUsers", request);
        };
        securityService.getCustomerUser = function (customerUserId){
            return axios.get("/api/SecurityService/GetCustomerUser?customerUserId=" + customerUserId);
        };
        securityService.getOrderTypePermissions = function (){
            return axios.get("/api/SecurityService/GetOrderTypePermissions");
        };
        return securityService;
    }
    //define globally if it doesn't already exist
    if (typeof (securityService) === "undefined") {
        window.securityService = defineSecurityService();
    } else {
        console.log("securityService already defined.");
    }
})(window);